import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import type { ConversationMessage } from "~/api/ideTypes";

import "~/features/work/work.css";
import { Prose } from "~/features/work/Prose";

/** Shared Markdown typography for human and agent messages. */
export function MarkdownText({ content }: { content: string }) {
  return <Prose text={content} />;
}

export function Transcript({
  messages,
  awaitingReply,
  workingStatus,
}: {
  messages: ConversationMessage[];
  awaitingReply: boolean;
  workingStatus: string | null;
}) {
  const { t } = useTranslation();
  const endRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ block: "end" });
  }, []);

  return (
    <div className="flex flex-col gap-3">
      {messages.map((message) => (
        <div
          key={message.id}
          dir="auto"
          className={
            message.role === "user"
              ? "docit-human-text self-end rounded-md px-3 py-2 text-body text-text"
              : "docit-ai-text rounded-md px-3 py-2 text-body text-text"
          }
        >
          <MarkdownText content={message.content} />
        </div>
      ))}

      {workingStatus ? (
        <p className="text-small text-text-tertiary">
          {t("The IDE is working ({{status}})", { status: workingStatus })}
        </p>
      ) : awaitingReply ? (
        <p className="text-small text-text-tertiary">{t("Waiting for the IDE to answer…")}</p>
      ) : null}

      <div ref={endRef} />
    </div>
  );
}
